<template>
  <v-select class="app-select" outlined dense v-bind="$attrs" v-on="$listeners">
    <template v-for="(_, slot) in $scopedSlots" #[slot]="scope">
      <slot :name="slot" v-bind="scope || {}" />
    </template>

    <!-- NÃO renomear `plainSlot` para `slot`: o compilador indexa `el.scopedSlots` pela expressão do
         nome dinâmico, então dois v-for escritos `#[slot]` colidem nessa chave e o segundo descarta o
         primeiro EM TEMPO DE COMPILAÇÃO, sumindo com todos os slots COM escopo. Sem erro nem warning. -->
    <template v-for="(_, plainSlot) in $slots" #[plainSlot]>
      <slot :name="plainSlot" />
    </template>
  </v-select>
</template>

<script>
export default {
  name: 'AppSelect',
}
</script>

<style scoped>
.app-select ::v-deep .v-input__control > .v-input__slot {
  border-radius: 10px !important;
}
</style>
